// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#notifyBtn,
#chatBtn {
  position: relative;
}

/* #notify-badge,
#chat-badge,
#menu-badge-ctrl {
    position: absolute;
    top: 0px;
    right: 0px;
    border-radius: 50%;
} */
.menu-badges-align {
  width: 100%;
  height: 100%;
}

ion-icon {
  font-size: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notifys-badges/notifys-badges.component.scss"],"names":[],"mappings":"AAAA;;EAEI,kBAAA;AACJ;;AAEA;;;;;;;GAAA;AASA;EACI,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ","sourcesContent":["#notifyBtn,\n#chatBtn {\n    position: relative;\n}\n\n/* #notify-badge,\n#chat-badge,\n#menu-badge-ctrl {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    border-radius: 50%;\n} */\n\n.menu-badges-align {\n    width: 100%;\n    height: 100%;\n}\n\nion-icon {\n    font-size: 1.2em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
